import React from 'react';
import { Modal, Alert, Button } from '@deere/ux.uxframe-react';

export const ModalGeneric = ({showModal, 
                              setShowModal, 
                              labelBtnPrimary, 
                              labelBtnSecondary, 
                              handleSubmit,
                              msgModal,
                              titleModal,
                              onClose}) => {

 
    function closeModal( ) {
        if (onClose)
            onClose()
       else
            setShowModal(false)
    }
    
    return (
        <Modal show={showModal} onHide={handleSubmit} backdrop='static'>
        <Modal.Header>
            <Modal.Title>{titleModal}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="overflow-hidden">
            <Alert variant="warning">
                <h5 className="uxf-alert-title">
                    {msgModal}
                </h5>
            </Alert>
        </Modal.Body>
        <Modal.Footer>
            <Button 
                variant="secondary"
                onClick={closeModal} 
              >
                {labelBtnSecondary}</Button>
            <Button
                type="submit"
                variant="primary"
                onClick={handleSubmit}
            >
                {labelBtnPrimary}
            </Button>
        </Modal.Footer>
    </Modal>
    )
}